// extracted by mini-css-extract-plugin
module.exports = {"inPageSearchWrapper":"v1_inPageSearchWrapper__iTzIz"};